import React from 'react';
import { TcbFileItem } from '../models/models';
export function loadingDiv() {

    return (
        <div className="k-loading-mask">
            <span className="k-loading-text">Loading</span>
            <div className="k-loading-image"></div>
            <div className="k-loading-color"></div>
        </div>)
}
   

export function downloadFileItem(f: TcbFileItem) {

    if (!f.fileDataStr) return;

    let href = "";
    switch (f.fileExt.toLowerCase()) {
        case ".csv":
        case ".txt":
            href = "data:application/octet-stream;base64,";
            break;
        case ".xls":
            href = "data:application/vnd.ms-excel;base64,";
            break;
        case ".xlsx":
            href = "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
            break;
        case ".doc":
            href = "data:application/msword;base64,";
            break;
        case ".docx":
            href = "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,";
            break;
        case ".ppt":
        case ".pptx":
            href = "data:application/octet-stream;base64,";
            break;
        case ".pdf":
            href = "data:application/pdf;base64,";
            break;
        case ".zip":
            href = "data:application/octet-stream;base64,";
            break;
        case ".jpg":
            href = "data:image/jpg;base64,";
            break;
        case ".gif":
            href = "data:image/gif;base64,";
            break;
        case ".png":
            href = "data:image/png;base64,";
            break;
        case ".nwd":
            href = "data:application/octet-stream;base64,";
            break;     
    }
    // return (<td><a href={href + fi.thumbnailStr} download={fi.fileName} ><span className={"k-icon " + icon} /></a></td>);

    const link = document.createElement('a');
    link.href = href + f.fileDataStr;
    link.download = f.fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export function downloadBlob(blob: Blob, fileName: string) {
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
}

// Convert a Blob to a base64 string (without the data:<mime>;base64, prefix)
export function blobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            const result = reader.result as string;
            const idx = result.indexOf(',');
            const base64 = idx >= 0 ? result.substring(idx + 1) : result;
            resolve(base64);
        };
        reader.onerror = (err) => reject(err);
        reader.readAsDataURL(blob);
    });
}

// Convert a base64 string to a Blob. Optionally provide mime type.
export function base64ToBlob(base64: string, mimeType?: string): Blob {
    const byteChars = atob(base64);
    const byteNumbers = new Array(byteChars.length);
    for (let i = 0; i < byteChars.length; i++) {
        byteNumbers[i] = byteChars.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: mimeType || 'application/octet-stream' });
}